import { Link } from 'react-router-dom';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { Shield } from 'lucide-react';

export function AdminAccessLink() {
  const { isAdmin, isLoading } = useAdminAuth();

  if (isLoading || !isAdmin) {
    return null;
  }

  return (
    <Link 
      to="/admin" 
      className="inline-flex items-center gap-2 text-xs text-muted-foreground hover:text-primary transition-colors"
    >
      <Shield className="h-3 w-3" />
      Admin Dashboard
    </Link>
  );
}